export enum RoleEnums {
  ADMIN = 'Admin',
  CREATOR = 'Creator',
  VIEWER = 'Viewer',
}

export const ROLE_IDS = {
  MERIDIA_ADMIN: 1,
  ADMIN: 2,
  CREATOR: 3,
  VIEWER: 4,
} as const;
